export default class QueryResourceParams {
    /**
     * @type {string}
     * @memberof QueryResourceParams
     * @name 资源分类ID
     */
    public categoryId: string
    /**
     * @type {string}
     * @memberof QueryResourceParams
     * @name 资源类型（VIDEO-视频，AUDIO-⾳频，DOCUMENT-⽂档）
     */
    public resourceType: string
    /**
     * @type {string}
     * @memberof QueryResourceParams
     * @name 转换类型(SUCCESS-成功，CONVERTING-转换中，FAIL-失败)
     */
    public convertType: string
    /**
     * @type {string}
     * @memberof QueryResourceParams
     * @name 文件名称
     */
    public title: string
    /**
     * @type {number}
     * @memberof QueryResourceParams
     * @name 开始时间戳
     */
    public startAt: number
    /**
     * @type {number}
     * @memberof QueryResourceParams
     * @name 结束时间戳
     */
    public endAt: number
    /**
     * @type {number}
     * @memberof QueryResourceParams
     * @name 当前页
     */
    public pageNumber: number
    /**
     * @type {number}
     * @memberof QueryResourceParams
     * @name 页的大小
     */
    public pageSize: number
    /**
     * @type {number}
     * @memberof QueryResourceParams
     * @name 资源最大限制，单位B
     */
    public maxSize: number
    constructor({
        categoryId = '',
        resourceType = null,
        convertType = null,
        title = null,
        startAt = null,
        endAt = null,
        pageNumber = 1,
        pageSize = 5,
        maxSize = null
    } = {}) {
        this.categoryId = categoryId
        this.resourceType = resourceType
        this.convertType = convertType
        this.title = title
        this.startAt = startAt
        this.endAt = endAt
        this.pageNumber = pageNumber
        this.pageSize = pageSize
        this.maxSize = maxSize
    }
}